

define(['angular', 'squid/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-guest-upgrade-interstitial.route', ['squid', 'xo-guest-upgrade-interstitial.directive']).factory('$GuestUpgradeInterstitialRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('GuestUpgradeInterstitialRoute', {

            name: 'guestUpgradeInterstitial',
            directive: 'xo-guest-upgrade-interstitial',
            trackingData: {
                fptiState: 'guest_xo_upgrade_interstitial',
                trackStateExit: false,
                pageQualifier: 'guest',
                buzname: {
                    'guest': {
                        'pagename': '%::fullpage-guest-upgrade-interstitial',
                        'pagename2': '%::fullpage-guest:member:hermes:',
                        'version': 'guest:%:'
                        // More page qualifiers come here...
                    } }
            },
            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest-upgrade-interstitial/route.js
// module id = ./components/xo-guest-components/src/guest-upgrade-interstitial/route.js
// module chunks = 1